<div class="duna-event-form-page">
  <app-dynamic-form [dynamicInput]="dynamicInput"></app-dynamic-form>
</div>
